import { isArray } from "@suse-o11y/is-array";
import React from "react";

import { Context } from "./context";
import { type TemplateVariableDefinition, TemplateVariableDefinitions } from "./definitions";

export interface TemplateVariablesBoundaryProps {
	variables: TemplateVariableDefinitions | ReadonlyArray<TemplateVariableDefinition>;
	children: React.ReactNode;
}

export const TemplateVariablesBoundary: React.FC<TemplateVariablesBoundaryProps> = ({ variables, children }) => {
	const context = React.useMemo(
		() => (isArray(variables) ? new TemplateVariableDefinitions(variables) : variables),
		[variables],
	);

	return <Context.Provider value={context}>{children}</Context.Provider>;
};
